import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = { clickMessage: String }

  connect() {
    console.log('[ProfileCompletion] Simple controller connected!')
  }

  sendConfirmation(event) {
    console.log('[ProfileCompletion] sendConfirmation called!')
    event.preventDefault()
    const msg = this.clickMessageValue || ''
    if (msg) {
      alert(msg)
    }
  }
}
